var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"datasets":_vm.datasets,"options":_vm.dataoptions,"height":229}})}
var staticRenderFns = []

export { render, staticRenderFns }